import { render, staticRenderFns } from "./DataTableV2ItemView.html?vue&type=template&id=c4286820&scoped=true&external"
import script from "./DataTableV2ItemView.js?vue&type=script&lang=js&external"
export * from "./DataTableV2ItemView.js?vue&type=script&lang=js&external"
import style0 from "./DataTableV2ItemView.css?vue&type=style&index=0&id=c4286820&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4286820",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VIcon,VSpacer,VToolbar})
